<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import preventionbrigadeAPI from "@/services/standards/preventionbrigade/preventionbrigadeAPI";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI"
import Pagination from "@/components/standard/preventionbrigade/preventionbrigadePagination";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import Swal from "sweetalert2";
import { sendNotification } from "@/utils/helpers/notification"
import CheckModal from "@/components/CheckModal"
import { dateFormat } from "@/utils/helpers/format";
import ItemAPI from "@/services/items/itemsAPI";

/**
 * Form elements component
 */
export default {
  page: {
    title: "5.1.2 Brigada de emergencias",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
    Pagination,
  },
  data() {

    return {
      title: "5.1.2 Brigada de emergencias",
      items: [

        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "5.1.2 Brigada de emergencias",
          active: true,
        },
      ],

      lista: [],
      file: null,
      lastId: 1,
      item: null,
      itemStatus: "No cumplido",
      submitted: false,
      itemData: null,
      preventionbrigade: {
        file: "datos",
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },
      nit: this.$store.getters["company/getCompany"].nit || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      search: "",
      loading: true,
    };
  },
  methods: {

    fetch() {
      this.loading = true;
      this.$refs.paginator.query();
    },

    getItemData() {
      ItemAPI.getItems(52)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 52)
        .then(response => {
          this.item = response || null
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch(error => {
          console.log(error)
        })
    },

    changeItemStatus(itemStatus) {
      const itemChange = {
        companies_id: this.companyID,
        item_id: 52,
        status: itemStatus,
      };
      newScoresAPI.calculateScores(itemChange)
        .then((response) => {
          Swal.fire({
            title: "¡Éxito!",
            text: "¡Se ha cambiado el estado del ítem con éxito!",
            icon: "success",
            style: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 2000)
        })
        .catch((error) => {
          Swal.fire({
            title: "¡ERROR!",
            text: "¡No se ha actualizado el estado del ítem!",
            icon: "error",
            style: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });

          setTimeout(() => window.location.reload(), 2000)
          console.log(error);
        });
    },

    /**
         * This method is used to send notification to SST user and SST company.
         * The sendNotification method import is required.
         * @param {Number} messageID - The message ID that will be associated to notification.
         * @param {Number} itemID - The item ID that will be associated to notification.
         * @param {Boolean} user - The user that will e associated to notification.
         * @return {Boolean} True if the notification is sent, false if not.
         */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },

    /**
    * This method is used to knows if the user has the permission indicated
    * @param {String} name The name of the permission
    * @param {Array} roles the roles that permitted to access the action 
    * @returns {Boolean} true if the user has the permission indicated or false if no
    */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions
        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    /**
   * This method is used to redirect to the page indicated
   * @param {String} page The page to redirect
   */
    goPage(page) {
      window.location.href = page
    },

    getFile(file) {
      try {
        const name = file.split("/");
        return name[name.length - 1];
      } catch (error) {
        return file;
      }
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/5.1.2/${this.lastId}/${this.file.name}`;
        } else {
          url = `sst-prod/${this.nit}/5.1.2/${this.lastId}/${this.file.name}`;
        }
        const result = await uploadDocument(url, this.file);
        if (result) {
          this.preventionbrigade.file = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    getList() {
      preventionbrigadeAPI.getAllIBrigadeCompany(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          this.lista = response.Prevention_brigades.data;
          if (response.Prevention_brigades.data[0]['id']) {
            this.lastId = this.lastId + 1
          }
          if (Array.isArray(this.lista)) {
            this.deleteCount = this.lista.length;
          } else {
            this.deleteCount = 0;
          }
          this.loading = false
        })
        .catch((error) => {
          console.log(error);
          this.loading = false
        });
    },

    async save() {
      this.submitted = true;
      this.loading = true
      let response = await this.uploadDocument();
      if (response) {
        preventionbrigadeAPI.save(this.preventionbrigade)
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 52,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.sendNotification(42, 52, true)
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Se ha registrado con éxito!",
                    type: "success",
                    icon: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload()
                }, 2000)
              })
              .catch((error) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
            this.loading = false
          });
      } else {
        this.loading = false
        setTimeout(() => {
          Swal.fire({
            title: "¡Error!",
            text: "¡No se ha podido registrar!",
            type: "warning",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
        }, 2000)
      }
    },

    deleteB(id) {
      preventionbrigadeAPI.delete(id)
        .then((data) => {
          if (this.deleteCount > 0) {
            this.deleteCount -= 1;
          }
          const newStatus = this.deleteCount > 0 ? 'Pendiente' : 'No Cumplido';
          const itemChange = {
            companies_id: this.companyID,
            item_id: 52,
            status: newStatus,
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              Swal.fire({
                title: "¡Éxito!",
                text: "¡Se ha sido eliminado con exito!",
                type: "success",
                icon: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              window.location.reload();
            })
            .catch((error) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async print() {
      try {
        const url = 'https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/standards/FORMATO_BRIGADA_PREVENCION_EMERGENCIAS.docx'
        window.location.href = url
      } catch (error) {
        console.log(error);
      }
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

  },

  mounted() {
    this.getItems()
    this.getList();
    this.getItemData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">

                  <CheckModal>
                    <p class="text-justify">
                      Elaborar acta de la conformación de la brigada de prevención, preparación y respuesta ante
                      emergencias e incluir en el ítem 1.2.1 la capacitación a este equipo. Entregar dotación para el
                      desempeño de sus funciones como son: Elementos de protección Personal, botiquines, extintores,
                      distintivos, entre otros.
                    </p>
                  </CheckModal>
                </div>

                <div class="col-6 text-right m-b-0">

                  <label for="">Formato ejemplo de acta de constitución brigadista</label>

                  <button :disabled="!allowAccess()" @click="print" class="btn btn-primary mx-1" id="tooltip">
                    <span class="btn-label"> <i class="bx bx-download"></i></span> Descargar formato de brigada de prevención y preparación ante emergencias
                  </button>

                  <b-tooltip target="tooltip" placement="left">
                    Descargar formato de brigada de prevención y preparación ante emergencias
                  </b-tooltip>
                </div>

              </div>

              <div class="row">
                <div class="col-6"></div>
                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>

              </div>

              <form class="form-group" @submit.prevent="save">
                <div class="form-row pt-3">

                  <b-form-group class="col-md-12 px-2" label="Subir acta de constitución brigadistas" label-for="file">
                    <b-form-file :disabled="!getRole('Crear') || !allowAccess()" required type="file" id="file"
                      ref="file" name="file" browse-text="Buscar" :placeholder="`Selecciona un archivo...`"
                      drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="submitted" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>

                <hr v-if="getRole('Consultar')" />

                <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                  <div class="col-lg-12">
                    <div class="card-body">
                      <div class="row pb-3">
                        <div class="col-6">
                          <div class="form-row row text-center">
                            <form @submit.prevent="fetch()" class="form-inline">
                              <div class="col-sm-11 col-md-5">
                                <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                                  class="form-control px-2" placeholder="Buscar"></b-form-input>
                              </div>
                              <div class="col-sm-1 pl-5">
                                <button type="submit" class="btn btn-primary px-2">Buscar</button>
                              </div>

                            </form>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="form-group text-right m-b-0">
                            <button onclick="window.location.href='/forms/estandares/brigada-prevencion-capacitacion'"
                              :disabled="!getRole('Crear') || !allowAccess()" type="button" class="btn btn-primary">
                              Crear Capacitación
                            </button>
                            <button onclick="window.location.href='/forms/estandares/ver-capacitaciones'" type="button"
                              class="btn btn-primary mx-1">
                              Ver Capacitaciones
                            </button>
                          </div>
                        </div>
                      </div>

                      <div class="table-responsive">
                        <div v-if="!loading">
                          <table class="
                            pt-2
                            table
                            border-bottom
                            divide-y divide-gray-200
                            table-striped
                            rounded
                          ">
                            <thead>
                              <tr>
                                <th class="text-center align-middle">Id</th>

                                <th class="text-center align-middle">Fecha</th>

                                <th class="text-center align-middle">Archivo</th>
                                <th class="text-center align-middle">Acciones</th>
                              </tr>
                            </thead>
                            <tbody class="bg-white divide-y divide-gray-200">
                              <tr v-for="dato in lista" :key="dato.id">
                                <td class="text-center align-middle">
                                  {{ dato.id }}
                                </td>
                                <td class="text-center align-middle">
                                  {{ dateConvert(dato.created_at) }}
                                </td>


                                <td class="text-center align-middle">
                                  <div v-if="dato.file === null">
                                    <h6>No hay archivo disponible
                                    </h6>
                                  </div>
                                  <div v-else>
                                    <button :disabled="!allowAccess()"
                                      style=" background-color: transparent !important; border: none;" type="button"
                                      @click="gotoDigitalOcean(`${dato.file}`)"> <i class="mdi mdi-cloud-download"></i>
                                    </button>
                                  </div>
                                </td>

                                <td class="text-center align-middle">
                                  <div class="col-sm-12">
                                    <b-dropdown :disabled="!allowAccess()" variant="primary">
                                      <template v-slot:button-content>
                                        <i class="mdi mdi-eye"></i>
                                      </template>
                                      <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()"
                                        :to="{ path: `/forms/estandares/brigada-prevencion-editar/${dato.id}` }">Editar</b-dropdown-item>
                                      <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()"
                                        v-on:click="deleteB(dato.id)">Eliminar</b-dropdown-item>
                                      <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()"
                                        :to="{ path: `/forms/estandares/brigada-evidencia/${dato.id}` }">Evidencia
                                        capacitaciones</b-dropdown-item>
                                    </b-dropdown>
                                  </div>
                                </td>
                              </tr>

                            </tbody>
                          </table>
                        </div>
                        <div v-else>
                          <div class="text-center pt-2">
                            <b-spinner variant="primary" label="Loading..."></b-spinner>
                          </div>
                        </div>
                        <div>
                          <Pagination @loading="(load) => (loading = load)" ref="paginator" :search="search"
                            @fetch="(items) => (lista = items)" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- end col -->
                </div>
              </form>

            </div>
          </div>

        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>